import type { ReactNode } from 'react';

export interface StatusRowProps {
  readonly term: string;
  readonly children: ReactNode;
}

export function StatusRow({ term, children }: StatusRowProps) {
  return (
    <div className="flex items-baseline justify-between gap-4">
      <dt className="text-ink-secondary">{term}</dt>
      <dd>{children}</dd>
    </div>
  );
}
